import { v4 as uuidv4 } from 'uuid'

const backendDomain = process.env.NODE_ENV === 'production' ? 'https://backend-fm-auswahlhilfe.bayka.de' : 'http://localhost:8100'

const getUUID = () => uuidv4()

export default { backendDomain, getUUID }
